import { Component } from '@angular/core';
import { nodeType } from 'src/app/core/constants/constants';
import { FlowBuilderService } from 'src/app/core/service/flow-builder.service';
import { SubSink } from 'subsink';

@Component({
  selector: 'app-flow-right-section',
  templateUrl: './flow-right-section.component.html',
  styleUrls: ['./flow-right-section.component.scss']
})
export class FlowRightSectionComponent {
  public lastSelectedNode!: HTMLElement;
  public lastSelectedNodeType!: string;
  private subs: SubSink = new SubSink();
  public nodeTypes: any = nodeType;


  constructor(public _flowBuilder: FlowBuilderService){
    this.subs.add(
      this._flowBuilder.nodeDoubleClick$.subscribe((res: string | any) => {
        this.onNodeDoubleClick(res.type, res.element);
      }
      ));
  }


  ngOnInit(): void {}


  onNodeDoubleClick(type: string, element: HTMLElement) {
    this._flowBuilder.clickFlag = -1;
    this.lastSelectedNode = element;
    this.lastSelectedNodeType = type;

  }




}
